<template>
    <layout-authenticated>
        <v-breadcrumbs :items="breadcrumb"></v-breadcrumbs>
        <h1 class="mb-3">{{ $t('orders.order_no', {n: orderId}) }}</h1>
        <order-detail v-if="order" :order="order"/>
        <v-skeleton-loader v-else type="card"/>
    </layout-authenticated>
</template>

<script>
import SnackbarMixin from '@/mixins/SnackbarMixin'
import {API} from '@/api/api'
import OrderDetail from '@/components/user/orders/OrderDetail'
import LayoutAuthenticated from "@/layouts/LayoutAuthenticated";

export default {
    name: "Order",
    mixins: [SnackbarMixin],
    components: {LayoutAuthenticated, OrderDetail},
    data: () => ({
        // loading
        isBusyOrder: false,
        // order
        order: null
    }),
    computed: {
        orderId() {
            return this.$route.params.orderId;
        },
        breadcrumb() {
            return [
                {
                    text: this.$t('app.name'),
                    href: '/'
                },
                {
                    text: this.$t('orders.orders_and_bulk_orders'),
                    href: '/orders'
                },
                {
                    text: this.$t("orders.order_no", {n: this.orderId}),
                    href: '/orders/' + this.orderId,
                    disabled: true
                }
            ];
        }
    },
    methods: {
        fetchOrder() {
            this.isBusyOrder = true;
            API.get("/api/orders/" + this.orderId)
                .then(response => {
                    this.order = response.data;
                })
                .catch(error => {
                    this.snackbarError(error);
                })
                .finally(() => {
                    this.isBusyOrder = false;
                });
        }
    },
    created() {
        this.fetchOrder();
    }
}
</script>
